// Per-indicator classification: which pane does each one draw into?
//
// ATR moved from "overlay" to its own subchart type -- ATR's ~$0.50-3 range
// is meaningless plotted against a $50-300 price y-domain, which is exactly
// why it silently rendered as a flat, useless line at the bottom of the
// price pane before this fix.
//
// Parabolic-SAR/Ichimoku/Keltner-Channels are now their own real types
// (previously all lumped under the generic "overlay" line-drawer, which
// expects a flat number array but these three return structured objects --
// they silently rendered nothing at all).
export const indicatorTypes = {
  // Overlay indicators (drawn on the main price pane)
  SMA: 'overlay',
  EMA: 'overlay',
  'Bollinger-Bands': 'bollinger_bands',
  'Parabolic-SAR': 'parabolic_sar',
  Ichimoku: 'ichimoku',
  'Keltner-Channels': 'keltner_channels',

  // Subchart indicators (own stacked pane below price/volume)
  ATR: 'atr',
  MACD: 'macd',
  RSI: 'rsi',
  'Stochastic-Oscillator': 'stochastic',
  ADX: 'adx',
  OBV: 'subchart',
  CMF: 'subchart',
  CCI: 'subchart',
  'Williams-R': 'subchart',
  AROON: 'subchart',
  MFI: 'subchart',
  ROC: 'subchart',
  CMO: 'subchart',
  RVI: 'subchart',
  'Elder-Ray': 'subchart',
};

export const OVERLAY_TYPES = new Set([
  'overlay',
  'bollinger_bands',
  'parabolic_sar',
  'ichimoku',
  'keltner_channels',
]);

export const SUBCHART_TYPES = new Set(['subchart', 'macd', 'rsi', 'stochastic', 'adx', 'atr']);

export const isOverlayIndicator = (label) => OVERLAY_TYPES.has(indicatorTypes[label]);
export const isSubchartIndicator = (label) => SUBCHART_TYPES.has(indicatorTypes[label]);
